import Auth from "@/pages/Auth.vue";
import Admin from "@/pages/Admin.vue";
import User from "@/pages/User.vue";
import Error from '@/pages/Error.vue'
import {createRouter, createWebHistory} from "vue-router";

const routes = [
    {
        path: '/admin',
        component: Auth
    },
    {
        path: '/admin/login',
        component: Auth
    },
    {
        path: '/admin/adminPage',
        component: Admin
    },
    {
        path: '/admin/userPage',
        component: User
    },
    {
        path: '/:pathMatch(.*)*',
        component: Error
    },
]

const router = createRouter({
    routes,
    history: createWebHistory(process.env.BASE_URl)
})

export default router;

